import React, { useState, useEffect, FC } from 'react';

import Card from '@mui/material/Card';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import AddIcon from '@mui/icons-material/Add';
import PriceChangeOutlinedIcon from '@mui/icons-material/PriceChangeOutlined';
import { NFTStorage } from 'nft.storage';
import { FileUploader } from "react-drag-drop-files";
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { useWallet } from '@solana/wallet-adapter-react';
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import { Connection, PublicKey, clusterApiUrl } from '@solana/web3.js';
import * as anchor from '@project-serum/anchor';
import axios from 'axios';
import { getParsedNftAccountsByOwner } from "@nfteyez/sol-rayz";
import { Wallet } from '@project-serum/anchor/dist/cjs/provider';
import idl from "../../idl/sol_mint_nft.json";
import './index.scss';
require('@solana/wallet-adapter-react-ui/styles.css');
const { TOKEN_PROGRAM_ID, ASSOCIATED_TOKEN_PROGRAM_ID } = require("@solana/spl-token");

const APIKEY = process.env.REACT_APP_NFT_STORAGE_API_KEY || "";
const uploadFileTypes = ["JPG", "PNG", "GIF", "SVG", "MP4", "WEBM", "MP3", "WAV", "OGG", "GLB", "GLTF", "MOV"];
const opts: any = {
    preflightCommitment: "processed"
};
const TOKEN_METADATA_PROGRAM_ID = new anchor.web3.PublicKey(
    "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s"
);
const programID = new PublicKey(idl.metadata.address);

const MintNFT = () => {

    const wallet = useWallet();
    const network = clusterApiUrl(WalletAdapterNetwork.Devnet);
    const connection = new Connection(network, opts.preflightCommitment);

    const [uploadingNow, setUploadingNow] = useState(false);
    const [primaryDataFile, setPrimaryDataFile] = useState<any>();
    const [nftName, setNftName] = useState('');
    const [uploadedImage, setUploadedImage] = useState('');
    const [nftDescription, setNftDescription] = useState('');

    const [traitType, setTraitType] = useState('');
    const [traitValue, setTraitValue] = useState('');
    const [nftRoyalty, setNftRoyalty] = useState('');
    const [allProperty, setAllProperty] = useState<any>([]);
    const [uploadedMetaData, setUploadedMetaData] = useState('');

    const getProvider = async () => {
        /* create the provider and return it to the caller */
        /* network set to local network for now */

        const provider = new anchor.AnchorProvider(
            connection, wallet as Wallet, opts.preflightCommitment,
        );
        return provider;
    }

    const mintFunction = async (metaDataUri: any, metaTitle: any) => {

        // const testNftTitle = "My NFT";
        const testNftSymbol = "MNN";
        // const testNftUri = "https://raw.githubusercontent.com/Coding-and-Crypto/Solana-NFT-Marketplace/master/assets/example.json";

        const mintKeypair: anchor.web3.Keypair = anchor.web3.Keypair.generate();
        const tokenAddress = await anchor.utils.token.associatedAddress({
            mint: mintKeypair.publicKey,
            owner: wallet?.publicKey!
        });

        console.log("mint address: ", mintKeypair.publicKey.toString());
        console.log("owner address: ", wallet.publicKey?.toString());
        console.log(tokenAddress.toBase58());

        const provider = await getProvider();
        const program = new anchor.Program(idl as any, programID, provider);

        const metadataAddress = (await anchor.web3.PublicKey.findProgramAddress(
            [
                Buffer.from("metadata"),
                TOKEN_METADATA_PROGRAM_ID.toBuffer(),
                mintKeypair.publicKey.toBuffer(),
            ],
            TOKEN_METADATA_PROGRAM_ID
        ))[0];

        console.log("==========metadataAddress=========", metadataAddress.toBase58());

        const masterEditionAddress = (await anchor.web3.PublicKey.findProgramAddress(
            [
                Buffer.from("metadata"),
                TOKEN_METADATA_PROGRAM_ID.toBuffer(),
                mintKeypair.publicKey.toBuffer(),
                Buffer.from("edition"),
            ],
            TOKEN_METADATA_PROGRAM_ID
        ))[0];

        console.log("==========masterEditionAddress=========", masterEditionAddress.toBase58());

        const tx = await program.methods.mint(
            metaTitle, testNftSymbol, metaDataUri, new anchor.BN(1) // the last variable (supply should be removed in next version)
        )
            .accounts({
                metadata: metadataAddress,
                masterEdition: masterEditionAddress,
                mint: mintKeypair.publicKey,
                tokenAccount: tokenAddress,
                mintAuthority: wallet?.publicKey!,
                rent: anchor.web3.SYSVAR_RENT_PUBKEY,
                systemProgram: anchor.web3.SystemProgram.programId,
                tokenProgram: TOKEN_PROGRAM_ID,
                associatedTokenProgram: ASSOCIATED_TOKEN_PROGRAM_ID,
                tokenMetadataProgram: TOKEN_METADATA_PROGRAM_ID,
            })
            .signers([mintKeypair])
            .rpc();

        console.log("tx: ", tx);
    }

    const handleFileUpload = (file: any) => {
        setPrimaryDataFile(file);

        uploadNFT(file, 'New NFT', 'No Description');
    }

    const uploadNFT = async (uploadFile: any, nftName: any, nftDescription: any) => {
        //Initialize NFTStorage
        const nftStorage = new NFTStorage({ token: APIKEY });

        try {
            //Upload NFT to IPFS & Filecoin
            setUploadingNow(true);
            const metadata = await nftStorage.store({
                name: nftName,
                description: nftDescription,
                image: uploadFile
            });
            setUploadingNow(false);
            console.log(metadata);
            const pathname = metadata.data.image.pathname.split('//')[1];
            setUploadedImage('https://ipfs.io/ipfs/' + pathname);

        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    const handleNftNameChange = (e: any) => {
        setNftName(e.target.value);
    }

    const handleNftDescriptionChange = (e: any) => {
        setNftDescription(e.target.value);
    }

    const handleTraitTypeChange = (e: any) => {
        setTraitType(e.target.value);
    }

    const handleTraitValueChange = (e: any) => {
        setTraitValue(e.target.value);
    }


    const handleNftRoyaltyChange = (e: any) => {
        setNftRoyalty(e.target.value);
    }

    const handleAddProperty = () => {
        if (traitValue !== '') {
            let newProperty = {
                trait_type: traitType,
                value: traitValue,
            }
            let tempProperty = allProperty;
            tempProperty.push(newProperty);
            setAllProperty([...tempProperty]);
            console.log(tempProperty);
        }
        console.log(allProperty);
    }

    const handleMintNFT = async () => {
        if (!wallet?.publicKey) {
            alert("You should login at first");
            return;
        }


        const newMetaData = {
            "name": nftName,
            "symbol": "SNFT",
            "description": nftDescription,
            "seller_fee_basis_points": parseInt(nftRoyalty, 10) * 100,
            "image": uploadedImage,
            "attributes": allProperty,
        };

        console.log("uploaded metadata file: ", newMetaData);

        const nftStorage = new NFTStorage({ token: APIKEY });

        let uploadedMetaData;

        try {
            //Upload NFT to IPFS & Filecoin
            setUploadingNow(true);

            const cid = await nftStorage.storeBlob(new Blob([JSON.stringify(newMetaData)], { type: "text/plain" }));
            setUploadingNow(false);
            console.log("===========cid=============", cid);
            uploadedMetaData = 'https://ipfs.io/ipfs/' + cid;

        } catch (error) {
            console.log("error in uploading metadata to nft.storage: ", error);
            return;
        }

        console.log("=============uploadedMetaData==============", uploadedMetaData);

        // const uploadedMetaData = "https://ipfs.io/ipfs/bafkreigh6jutlxuldyqcxr3yuehx3snww5oqkac55sl3r4c77cpkipmzou";
        // const nftName = "My First NFT1";

        try {
            await mintFunction(uploadedMetaData, nftName);

            console.log("finished transaction");
            setNftName('');
            setUploadedImage('');
            setNftDescription('');
            setTraitType('');
            setTraitValue('');
            setAllProperty([]);
            setNftRoyalty('');
            console.log("=============================================================================");
            alert("NFT minted");

        } catch (error) {
            console.log("error in minting nfts: ", error);
        }

    }

    return (
        <div style={{ width: '100%', height: '110vh', backgroundColor: 'rgb(0, 0, 0, 20%)' }}>
            {/* <>
                {allNftData &&
                    allNftData.length > 0 &&
                    allNftData.map((val: any, ind: any) => {
                        console.log(val);
                        return (
                            <div className="col-4 mt-3" key={ind}>
                                <div className="cart text-center">
                                    <div className="img mt-4 pt-3">
                                        <img src={val?.image} alt="loading..." />
                                        <p className="mt-1">{val?.name}</p>
                                        <h6 className=" mt-2">
                                            {val?.description}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </> */}
            <Card className='mint-div'>
                <Typography variant="h6" color="rgb(255, 129, 0)">
                    CREAT NEW NFT
                </Typography>
                <Divider />
                <Backdrop
                    sx={{
                        color: '#fff',
                        zIndex: (theme) =>
                            theme.zIndex.drawer + 1
                    }}
                    open={uploadingNow}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'flex-end',
                        width: '80%',
                        position: 'absolute',
                        left: '13%',
                        top: '10vh'
                    }}>
                    <DriveFileRenameOutlineIcon
                        sx={{
                            color: 'action.active',
                            mr: 2,
                            my: 0.5
                        }} />
                    <TextField
                        id="nft-name"
                        label="NFT Name"
                        variant="standard"
                        sx={{ width: '85%' }}
                        onChange={handleNftNameChange}
                        value={nftName} />
                </Box>
                <div style={{
                    position: 'absolute',
                    left: '13%',
                    top: '20vh',
                    width: '75%'
                }}>
                    <FileUploader
                        multiple={false}
                        handleChange={handleFileUpload}
                        name="file"
                        types={uploadFileTypes}
                    />
                    <p
                        style={{
                            color: 'action.active',
                            marginTop: '1vh',
                            textAlign: 'right'
                        }}>
                        {primaryDataFile ?
                            `File name: ${primaryDataFile.name}` :
                            "No files uploaded yet"}
                    </p>
                </div>

                <TextField
                    id="standard-multiline-static"
                    label="Description"
                    multiline
                    rows={4}
                    variant="standard"
                    sx={{
                        position: 'absolute',
                        width: '74%',
                        left: '13%',
                        top: '29vh'
                    }}
                    onChange={handleNftDescriptionChange}
                    value={nftDescription}
                />
                <TextField
                    id="trait-type"
                    label="Trait_Type"
                    variant="standard"
                    sx={{ position: 'absolute', left: '13%', top: '47vh', width: '35%' }}
                    onChange={handleTraitTypeChange}
                    value={traitType} />

                <TextField
                    id="trait-value"
                    label="Trait_Value"
                    variant="standard"
                    sx={{ position: 'absolute', left: '52%', top: '47vh', width: '35%' }}
                    onChange={handleTraitValueChange}
                    value={traitValue} />

                <Button
                    variant='contained'
                    sx={{
                        position: 'absolute',
                        width: '74%',
                        left: '13%',
                        top: '57vh'
                    }}
                    onClick={handleAddProperty}
                >
                    <AddIcon sx={{ mr: 2 }} />
                    Add Property
                </Button>

                {allProperty.length > 0 ? (
                    <List
                        component="nav"
                        aria-label="main mailbox folders"
                        sx={{ position: 'absolute', left: '10%', top: '65vh', width: '77%', maxHeight: '17vh', overflowY: 'scroll' }}>
                        {allProperty.map((item: any, index: any) => {
                            return (
                                <ListItem key={index}>
                                    <Typography>
                                        Trait_Type: {item.trait_type} /
                                        Trait_Value: {item.value}
                                    </Typography>
                                </ListItem>)
                        })}
                    </List>
                ) : (<></>)}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'flex-end',
                        width: '80%',
                        position: 'absolute',
                        left: '13%',
                        top: '84vh'
                    }}>
                    <PriceChangeOutlinedIcon
                        sx={{
                            color: 'action.active',
                            mr: 2,
                            my: 0.5
                        }} />
                    <TextField
                        id="nft-royalty"
                        label="Royalty(%)"
                        variant="standard"
                        sx={{ width: '85%' }}
                        onChange={handleNftRoyaltyChange}
                        value={nftRoyalty} />
                </Box>
                <Button variant="contained" color="secondary" sx={{ position: 'absolute', left: '73%', top: '95vh' }} onClick={handleMintNFT}> Mint NFT </Button>
            </Card>
        </div>
    );

}

export default MintNFT;